export default __webpack_public_path__ + "static/media/MattOrlich.00461a86.png";